module.exports = __webpack_public_path__ + "media/images/athletes/4153-24591c21dd1227926496690195e369f7.png";